import { Link, useLocation } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc';
import { LEGAL_DOCS, getLegalDoc } from '../constants/legalContent';
import './LegalPage.css';

// Public and outside AuthGate on purpose: terms nobody can read without first
// creating an account are not much of an agreement, and the signup checkbox
// links straight here.
function LegalPage() {
  // One component serves /terms, /privacy and /disclaimer - the path is the key.
  const { pathname } = useLocation();
  const docKey = pathname.replace(/^\/+|\/+$/g, '');
  const doc = getLegalDoc(docKey);

  return (
    <div className="legal-page">
      <header className="legal-page-header">
        <Link to="/" className="legal-page-brand">
          KROSI<span>FIN</span>
        </Link>
        <nav className="legal-page-nav">
          {LEGAL_DOCS.map((d) => (
            <Link
              key={d.key}
              to={d.path}
              className={d.key === docKey ? 'active' : ''}
            >
              {d.title}
            </Link>
          ))}
        </nav>
      </header>

      <main className="legal-page-body">
        {doc ? (
          <LegalDoc doc={doc} />
        ) : (
          <div className="legal-doc">
            <h1 className="legal-doc-title">Not found</h1>
            <p>That document does not exist. Try one of the links above.</p>
          </div>
        )}
      </main>

      <footer className="legal-page-footer">
        <Link to="/">Back to Krosifin</Link>
        <span>
          ASA NEEDCFO Finvisors Private Limited · CIN U93090HR2017PTC070824
        </span>
      </footer>
    </div>
  );
}

export default LegalPage;
